import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { deleteCategory } from 'action/category'
import PropTypes from 'prop-types'
import confirmModal from 'view/component/confirm-modal'

const generateModalText = (name) => ({
  decide: {
    content: 'This action cannot be undone',
    title: `Are you sure you want to delete ${name}?`
  },

  outcome: {
    content: {
      error: 'Please try Again',
      success: `${name} has been successfully deleted. Any associated content has been moved to draft status.`
    },
    title: {
      error: `There has been an issue deleting ${name}`,
      success: 'Category deleted'
    }
  }
})

const DeleteCategory = ({ deleteCategory, category: { uuid, name } }) => {
  const { decide, outcome } = generateModalText(name)

  const handleSubmit = () => deleteCategory(uuid)
  const handleClick = () => confirmModal(handleSubmit, decide, outcome)

  return <a onClick={handleClick}>Delete Category</a>
}

DeleteCategory.propTypes = {
  category: PropTypes.object,
  deleteCategory: PropTypes.func
}

const mapDispatchToProps = (dispatch) => ({
  deleteCategory: bindActionCreators(deleteCategory, dispatch)
})

export default connect(null, mapDispatchToProps)(DeleteCategory)
